import { toGlobalId } from 'graphql-relay';
import { CardCompletionTypeEnum } from '../../../graphql/gqlTypes/transformToEnums/CardCompletionTypeEnum';
import { getPeerQuestionsForQuestion } from '../../../graphql/helpers/createPeerQuestions';

const getFieldOneCard = (offer, contentDetails, card, states, stateInteractions) => {
  const cardPerformance = states.find(state => state.contentId === card._id);
  const id = `${card._id.toString()}-${cardPerformance.userId.toString()}-${card.rootOfferId.toString()}`;
  const rawData = {};
  let questionsForReview = [];
  let questionAnswers = [];
  const offerType = card.offerType;
  if (offerType === 'peerReviewCard') {
    questionsForReview = card.children;
    questionsForReview = questionsForReview.map(questionForReview => ({
      ...questionForReview,
      states
    }));
  } else if (offerType === 'assignmentCard') {
    questionAnswers = card.children;
    questionAnswers.forEach(question => {
      const peerQuestions = getPeerQuestionsForQuestion(
        offer,
        question,
        cardPerformance.userId,
        states,
        stateInteractions
      );
      question.peerQuestions = peerQuestions;
    });
    questionAnswers = questionAnswers.map(questionAnswer => ({
      ...questionAnswer,
      states,
      stateInteractions
    }));
  }
  let minScore = 0;
  if (card.minScore !== null && card.minScore !== undefined) {
    minScore = card.minScore;
  }
  if (offerType === 'assignmentCard') {
    minScore = card.children.reduce((a, b) => {
      const childMinScore = b.minScore;
      return childMinScore ? a + childMinScore : a;
    }, 0);
  }
  let maxScore = 0;
  if (card.maxScore !== null && card.maxScore !== undefined) {
    maxScore = card.maxScore;
  }
  if (offerType === 'assignmentCard') {
    maxScore = card.children.reduce((a, b) => {
      const childMaxScore = b.maxScore;
      return childMaxScore ? a + childMaxScore : a;
    }, 0);
  }
  if (card.content.subType === 'objective') {
    rawData.card = { ...card };
    rawData.state = { ...cardPerformance };
    const transformedChildrens = card.children.map(cardQuestion => {
      const cardState = states.find(state => state.contentId === cardQuestion._id);
      return {
        cardQuestion,
        state: cardState
      };
    });
    rawData.card.children = transformedChildrens;
  }

  const cardPid = card._id.toString();

  const cardDetails = contentDetails && contentDetails[cardPid] ? contentDetails[cardPid] : {};
  if (cardDetails.narrationUrl) {
    card.content.narrationUrl = cardDetails.narrationUrl;
  }

  let isGradable = false;
  if ('isGradable' in card) {
    switch (offerType) {
      case 'cardQuestion':
        isGradable = card.isGradable && 'minScore' in card && 'maxScore' in card;
        break;
      case 'assignmentCard':
        isGradable = card.isGradable && 'successCriteria' in card && 'minScaledScore' in card;
        break;
      default:
        break;
    }
  } else {
    switch (offerType) {
      case 'cardQuestion':
        isGradable = 'minScore' in card && 'maxScore' in card;
        break;
      case 'assignmentCard':
        isGradable = card.successCriteria && card.minScaledScore;
        break;
      default:
        break;
    }
  }

  const fields = {
    id: toGlobalId('Card', id),
    pid: cardPid,
    name: card.content.name,
    rawData: JSON.stringify(rawData),
    globalPosition: card.content.globalPosition,
    description: card.content.description,
    blockInfo: card.content.blockInfo || [],
    hidden: card.content.hidden,
    desktopOnly: card.content.desktopOnly,
    newWindow: card.content.newWindow,
    duration: card.content.duration,
    type: card.content.contentType,
    contributeToSuccessStatus: isGradable,
    currentReviewCount: card.reviewsGiven && card.reviewsGiven.length,
    isGradable,
    reAttemptAllowed: card.reAttemptAllowed,
    reAttemptAllowedCount: card.reAttemptAllowedCount || 0,
    courseId: card.rootOfferId,
    hideAnswers: !!card.content.hideAnswers,
    minReviewCount: card.reviewCount,
    updatedAt: cardPerformance.updatedAt,
    hideMarkComplete: card.hideMarkComplete,
    completionType: CardCompletionTypeEnum[card.completionType],
    autoPlay: card.autoPlay,
    autoSwitch: card.autoSwitch,
    showPeerName: card.showPeerName,
    minProgressMeasure: card.minProgressMeasure,
    resource: card,
    minScaledScore: card.minScaledScore || 0,
    lessStrictCompletion: card.lessStrictCompletion,
    minScore,
    maxScore,
    questionsForReview,
    questionAnswers,
    stateInteractions,
    performance: {
      id: toGlobalId('CardPerformance', id),
      ...cardPerformance
    }
  };
  return fields;
};

export default getFieldOneCard;
